import { Component } from '@angular/core';
import { IntlService } from '@progress/kendo-angular-intl';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { orders } from 'src/app/resources/orders';
import { Order } from 'src/app/models/order.model';
import { NotificationService } from '@progress/kendo-angular-notification';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse } from 'src/app/models/base-http-response';
import { Site } from 'src/app/models/site.model';
import { DashboardLUG } from 'src/app/models/dasboardLUG.model';
import { ChartsModule } from '@progress/kendo-angular-charts';


@Component({
    selector: 'app-dashboardLuggage-component',
    templateUrl: './dashboardLuggage.component.html'
})
export class DashboardLuggageComponent {
    public selectedChart: 'Trend' | 'Volume' = 'Trend';
    public orders: Order[] = orders;
    public listItemsLocais: Array<Site> = [];
    public data: DashboardLUG = {
        id: 0,
        numeroArmarios: 0,
        numeroLocais: 0,
        numeroUtilizadores: 0,
        numeroEquipas: 0,
        numeroCacifosInibidos: 0,
        numeroCacifosOcupados: 0,
        dadosArmarios: [{
            nomeArmario: "",
            ocupacao: "",
            numeroReservasExpiradas: 0,
            numeroCacifosInibidos: 0,
            numeroCacifosOcupados: 0,
            numeroCacifosTotal: 0}
        ]
    };

    public customMsgService: CustomMessagesService;

    constructor(public intl: IntlService, public messages: MessageService, private api: ApiService, private notificationService: NotificationService,) {

        this.customMsgService = this.messages as CustomMessagesService;
        this.placeHolder.nome = this.customMsgService.translate('escolherLocal');

        this.api
            .getRequest<BaseHttpResponse<Site[]>>("Local/GetLocais")
            .then((data) => {
                this.listItemsLocais = data.value;

            })
            .catch((err) => { });
            
        this.customMsgService = this.messages as CustomMessagesService;
        this.load(undefined);
    }

    public placeHolder: any = {
        nome: "",
        id: undefined,
    };

    public selectionChange(value: Site): void {

        this.load(value.id);

    }

    load(idLocal: number | undefined) {
        let endpoint = idLocal == undefined ? "Dashboard/GetDadosLUG" : `Dashboard/GetDadosLUG?idLocal=${idLocal}`;
        this.api.getRequest<BaseHttpResponse<DashboardLUG>>(endpoint)
            .then((data) => {
                this.data = data.value;
                this.data.dadosArmarios.forEach(armario => {
                    armario.ocupacao = parseFloat(armario.ocupacao.replace(',', '.')).toString();
                });
            })
            .catch((err) => { console.error(err); });
    }
}
